import axiosInstance from ".";

export const getContact = () => {
  return axiosInstance.get("/contact");
};

export const updateContact = (data) => {
  return axiosInstance.post("/contact", data);
};
